import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { addCandidateToRole } from "api/roles.api";
import { cancelSearch, getRecentSearchList } from "api/search.api";

export interface SearchSlice {
  active_step: number;
  search_log: any;
  search_log_loading: number;
  active_search_role_id: any;
  search_name: any;
  job_titles: any;
  titles: any;
  locations: any;
  skills: any;
  universities: any;
  min_exp: number;
  max_exp: number;
  industries: any;

  industry_leaders: any;
  candidate_works: any;
  exclude_company: any;
  processing_search_id: any;
  agency_parents: any;
  agency_types: any;
  agencies: any;
  worked_previously_at_companies: boolean;
  industry_type: any;
  exclude_locations: any;
  active_search_role_name: string | null;
  include_subsidiaries: boolean;
}

const initialState: SearchSlice = {
  active_step: 0,
  search_log: [],
  search_log_loading: 1,
  active_search_role_id: null,
  search_name: "",
  job_titles: [],
  titles: [],
  locations: [],
  exclude_locations: [],
  skills: [],
  universities: [],
  min_exp: 0,
  max_exp: 100,
  industries: [],
  industry_leaders: [],
  candidate_works: [],
  exclude_company: [],
  agency_parents: [],
  agency_types: [],
  agencies: [],
  worked_previously_at_companies: false,
  include_subsidiaries: false,
  active_search_role_name: null,

  processing_search_id: null,
  industry_type: [],
};

export const doAddCandidateToRole = createAsyncThunk(
  "search/doAddCandidateToRole",
  async (payload: any, { dispatch }) =>
    addCandidateToRole(payload).then((res) => {
      return res;
    })
);
export const doGetSearchResultList = createAsyncThunk(
  "search/doGetSearchResultList",
  async (payload: any, { dispatch }) =>
    getRecentSearchList().then((res) => {
      return res;
    })
);
export const doSetResentSearchData = createAsyncThunk(
  "search/doSetResentSearchData",
  async (payload: any, { dispatch }) =>
    getRecentSearchList().then((res) => {
      return res;
    })
);

export const doCancelSearch = createAsyncThunk(
  "search/doCancelSearch",
  async (payload: any, { dispatch }) =>
    cancelSearch(payload).then((res) => {
      return res;
    })
);

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setActiveStep: (state, action: PayloadAction<any>) => {
      state.active_step = action.payload;
    },
    addName: (state, action: PayloadAction<any>) => {
      state.search_name = action.payload;
    },
    removeName: (state, action: PayloadAction<any>) => {
      state.search_name = "";
    },
    addJobTitle: (state, action: PayloadAction<any>) => {
      const jonTitles = state.job_titles.filter(
        (jobTitle: any) => jobTitle !== action.payload
      );

      state.job_titles = [...jonTitles, action.payload];
    },
    removeJobTitle: (state, action: PayloadAction<any>) => {
      state.job_titles = state.job_titles.filter(
        (jobTitle: any) => jobTitle !== action.payload
      );
    },
    removeAllJobTitle: (state, action: PayloadAction<any>) => {
      state.job_titles = [];
    },
    addModelCandidate: (state, action: PayloadAction<any>) => {
      state.job_titles = [];
    },
    removeLocation: (state, action: PayloadAction<any>) => {
      state.locations = state.locations.filter(
        (l: any) => l !== action.payload
      );
    },
    addLocation: (state, action: PayloadAction<any>) => {
      state.locations = [...state.locations, action.payload];
    },
    removeExcludeLocation: (state, action: PayloadAction<any>) => {
      state.exclude_locations = state.exclude_locations.filter(
        (l: any) => l !== action.payload
      );
    },
    addExcludeLocation: (state, action: PayloadAction<any>) => {
      state.exclude_locations = [...state.exclude_locations, action.payload];
    },

    addLocations: (state, action: PayloadAction<any>) => {
      const locs = state.locations.filter(
        (l: any) => action.payload.indexOf(l) === -1
      );
      state.locations = [...locs, ...action.payload];
    },

    addSkill: (state, action: PayloadAction<any>) => {
      const skills = state.skills.filter(
        (jobTitle: any) => jobTitle !== action.payload
      );

      state.skills = [...skills, action.payload];
    },
    removeSkill: (state, action: PayloadAction<any>) => {
      state.skills = state.skills.filter(
        (skill: any) => skill !== action.payload
      );
    },

    addUniversity: (state, action: PayloadAction<any>) => {
      const universities = state.universities
        ? state.universities.filter((uni: any) => uni !== action.payload)
        : [];

      state.universities = [...universities, action.payload];
    },
    removeUniversity: (state, action: PayloadAction<any>) => {
      state.universities = state.universities.filter(
        (uni: any) => uni !== action.payload
      );
    },

    addMinExp: (state, action: PayloadAction<any>) => {
      state.min_exp = action.payload;
    },
    addMaxExp: (state, action: PayloadAction<any>) => {
      state.max_exp = action.payload;
    },
    removeMinMaxExp: (state, action: PayloadAction<any>) => {
      state.min_exp = 0;
      state.max_exp = 100;
    },

    addIndustry: (state, action: PayloadAction<any>) => {
      const industries = state.industries.filter(
        (ind: any) => ind !== action.payload
      );

      state.industries = [...industries, action.payload];
    },
    removeIndustry: (state, action: PayloadAction<any>) => {
      state.industries = state.industries.filter(
        (uni: any) => uni !== action.payload
      );
    },
    addIndustryType: (state, action: PayloadAction<any>) => {
      const industries = state.industry_type.filter(
        (ind: any) => ind !== action.payload
      );

      state.industry_type = [...industries, action.payload];
    },
    removeIndustryType: (state, action: PayloadAction<any>) => {
      state.industry_type = state.industry_type.filter(
        (uni: any) => uni !== action.payload
      );
    },
    addIndustryLeader: (state, action: PayloadAction<any>) => {
      const indLeaders = state.industry_leaders.filter(
        (ind: any) => ind !== action.payload
      );

      state.industry_leaders = [...indLeaders, action.payload];
    },
    removeIndustryLeader: (state, action: PayloadAction<any>) => {
      state.industry_leaders = state.industry_leaders.filter(
        (uni: any) => uni !== action.payload
      );
    },
    addCandidateWorkCompany: (state, action: PayloadAction<any>) => {
      const indLeaders = state.candidate_works.filter(
        (ind: any) => ind !== action.payload
      );

      state.candidate_works = [...indLeaders, action.payload];
    },
    addCandidateWorkCompanyList: (state, action: PayloadAction<any>) => {
      state.candidate_works = action.payload;
    },
    removeCandidateWorkCompany: (state, action: PayloadAction<any>) => {
      state.candidate_works = state.candidate_works.filter(
        (uni: any) => uni !== action.payload
      );
    },
    addExcludeCompany: (state, action: PayloadAction<any>) => {
      const indLeaders = state.exclude_company.filter(
        (ind: any) => ind !== action.payload
      );

      state.exclude_company = [...indLeaders, action.payload];
    },
    removeExcludeCompany: (state, action: PayloadAction<any>) => {
      state.exclude_company = state.exclude_company.filter(
        (uni: any) => uni !== action.payload
      );
    },
    setRoleId: (state, action: PayloadAction<any>) => {
      state.active_search_role_id = parseInt(action.payload);
    },
    setRoleName: (state, action: PayloadAction<any>) => {
      state.active_search_role_name = action.payload;
    },
    resetRoleId: (state, action: PayloadAction<any>) => {
      state.active_search_role_id = null;
    },
    resetRoleName: (state, action: PayloadAction<any>) => {
      state.active_search_role_name = null;
    },
    setProcessingSearchId: (state, action: PayloadAction<any>) => {
      state.processing_search_id = action.payload;
    },
    removeProcessingSearchId: (state, action: PayloadAction<any>) => {
      state.processing_search_id = null;
    },
    setAgencyParent: (state, action: PayloadAction<any>) => {
      const parent = state.agency_parents
        ? state.agency_parents.filter((ind: any) => ind !== action.payload)
        : [];

      state.agency_parents = [...parent, action.payload];
    },
    removeAgencyParent: (state, action: PayloadAction<any>) => {
      state.agency_parents = state.agency_parents.filter(
        (uni: any) => uni !== action.payload
      );
    },
    setAgencyType: (state, action: PayloadAction<any>) => {
      const parent = state.agency_types.filter(
        (ind: any) => ind !== action.payload
      );

      state.agency_types = [...parent, action.payload];
    },
    setMultipleAgencyType: (state, action: PayloadAction<any>) => {
      state.agency_types = [...action.payload];
    },
    removeAgencyType: (state, action: PayloadAction<any>) => {
      state.agency_types = state.agency_types.filter(
        (uni: any) => uni !== action.payload
      );
    },
    setAgencies: (state, action: PayloadAction<any>) => {
      state.agencies = [...action.payload];
    },
    removeAgencies: (state, action: PayloadAction<any>) => {
      state.agencies = state.agencies.filter(
        (uni: any) => uni !== action.payload
      );
    },
    setModelCandidate: (state, action: PayloadAction<any>) => {
      state.job_titles = [...action.payload.job_titles];

      state.locations = [...action.payload.locations];
      state.skills = [...action.payload.skills];
      state.universities = [...action.payload.universities];

      state.industries = [...action.payload.industries];
      state.industry_leaders = [...action.payload.industry_leaders];
      state.candidate_works = [...action.payload.candidate_works];
    },

    setWorkOnPreviousCompany: (state, action: PayloadAction<any>) => {
      state.worked_previously_at_companies = action.payload;
    },

    setIncludeSubsidiaries: (state, action: PayloadAction<any>) => {
      state.include_subsidiaries = action.payload;
    },
    setSearch: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      const {
        active_search_role_id = null,
        search_name = "",
        job_title = [],
        titles = [],
        locations = [],
        skills = [],
        universities = [],
        min_exp = 0,
        max_exp = 100,
        industries = [],
        industry_leaders = [],
        candidate_works = [],
        exclude_company = [],
        agencies = [],
        agency_parents = [],
        agency_types = [],
        companyGroups = [],
        exclude_locations = [],
        include_subsidiaries = false,
        worked_previously_at_companies = false,
      } = payload;
      state.active_search_role_id = active_search_role_id;
      state.search_name = search_name;
      state.job_titles = job_title;
      state.titles = titles;
      state.locations = locations;
      state.skills = skills;
      state.universities = universities;
      state.min_exp = min_exp;
      state.max_exp = max_exp;
      state.industries = industries;
      state.industry_leaders = industry_leaders;
      state.candidate_works = candidate_works;
      state.exclude_company = exclude_company;
      state.agencies = agencies;
      state.agency_parents = agency_parents;
      state.agency_types = agency_types;
      state.processing_search_id = null;
      state.worked_previously_at_companies = worked_previously_at_companies;
      state.industry_type = companyGroups;
      state.exclude_locations = exclude_locations;
      state.active_search_role_name = null;
      state.include_subsidiaries = include_subsidiaries;
      state.active_step = 0;
    },

    resetSearch: (state, action: PayloadAction<any>) => {
      state.active_search_role_id = null;
      state.search_name = "";
      state.job_titles = [];
      state.titles = [];
      state.locations = [];
      state.skills = [];
      state.universities = [];
      state.min_exp = 0;
      state.max_exp = 100;
      state.industries = [];
      state.industry_leaders = [];
      state.candidate_works = [];
      state.exclude_company = [];
      state.agencies = [];
      state.agency_parents = [];
      state.agency_types = [];
      state.processing_search_id = null;
      state.worked_previously_at_companies = false;
      state.include_subsidiaries = false;
      state.industry_type = [];
      state.exclude_locations = [];
      state.active_search_role_name = null;
      state.active_step = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(doGetSearchResultList.pending, (state, action) => {
      state.search_log_loading = 1;
    });
    builder.addCase(doGetSearchResultList.fulfilled, (state, action) => {
      state.search_log_loading = 2;
      state.search_log = action.payload;
    });
    builder.addCase(doCancelSearch.fulfilled, (state, action) => {
      state.processing_search_id = null;
    });
  },
});
export const {
  addJobTitle,
  removeJobTitle,
  removeAllJobTitle,
  addLocation,
  removeLocation,
  addSkill,
  removeSkill,
  addUniversity,
  removeUniversity,
  addIndustry,
  removeIndustry,
  addIndustryLeader,
  removeIndustryLeader,
  addCandidateWorkCompany,
  removeCandidateWorkCompany,
  addExcludeCompany,
  removeExcludeCompany,
  removeMinMaxExp,
  addName,
  removeName,
  setRoleId,
  resetRoleId,
  setProcessingSearchId,
  removeProcessingSearchId,
  addMaxExp,
  addMinExp,
  resetSearch,
  setModelCandidate,
  setAgencies,
  setAgencyParent,
  setAgencyType,
  removeAgencies,
  removeAgencyParent,
  removeAgencyType,
  addLocations,
  addCandidateWorkCompanyList,
  setWorkOnPreviousCompany,
  setIncludeSubsidiaries,
  setMultipleAgencyType,
  addIndustryType,
  removeIndustryType,
  addExcludeLocation,
  removeExcludeLocation,
  setRoleName,
  resetRoleName,
  setActiveStep,
  setSearch,
} = searchSlice.actions;
export default searchSlice.reducer;
